import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    description: 'header for the add-on deactivation modal',
    defaultMessage: 'Deactivate {addOn} Add-On',
    id: 'fMJ1qL',
  },
  confirmation: {
    description: 'header for the add-on deactivation modal',
    defaultMessage: 'Are you sure you want to deactivate {addOn}?',
    id: 'Jo2on/',
  },
  endOfBillingCycle: {
    description: 'text informing that deactivated add ons will be available until the end of billing cycle',
    defaultMessage: 'Once deactivated, you can continue to use the {addOn} add-on until the end of the current billing cycle.',
    id: 'b9QIZz',
  },
  deactivateImmediate: {
    description: 'text informing that the deactivated add on will be removed immediately',
    defaultMessage: '{addOn} add-on will be removed immediately, not at the end of billing cycle.',
    id: 'si3N1n',
  },
  cancel: {
    description: 'cancel button text',
    defaultMessage: 'Cancel',
    id: 'E2qQyg',
  },
  deactivateAddOn: {
    defaultMessage: 'Deactivate',
    id: 'HukYdz',
    description: 'Button that deactivates an add-on subscription.',
  },
  deactivateAddOnSuccessNotificationTitle: {
    defaultMessage: '{addOnName} Deactivated',
    id: '2d3Ysa',
    description: 'Title of the notification that will show to inform the user they successfully deactivated an addon.',
  },
  deactivateAddOnSuccessNotificationText: {
    defaultMessage:
      'The {addOnName} Add-On has been deactivated. You can continue to use {addOnName} until the end of the current billing cycle.',
    id: 'BExKs2',
    description: 'Body text of the notification that will show to inform the user they successfully deactivated an addon.',
  },
  deactivateAddOnFailureNotificationTitle: {
    defaultMessage: '{addOnName} Failed to Deactivate',
    id: 'n9WAyA',
    description: 'Title of the notification that will show to inform the user there was a problem deactivating an addon.',
  },
  deactivateAddOnFailureNotificationText: {
    defaultMessage: 'ShipStation could not deactivate {addOnName} at this time. Please try again.',
    id: 'HQvMzy',
    description: 'Body text of the notification that will show to inform the use that there was a problem deactivating an addon.',
  },
  contactSupport: {
    defaultMessage: 'If you are still unable to deactivate, Contact Support',
    id: 'yieo/r',
    description: 'Button that will open a way to contact support.',
  },
  manageSetting: {
    defaultMessage: 'Manage {addOnName} Settings',
    id: 'pPjHu+',
    description: 'link that will allow the user to maneger the settings for the add-on that is being deactivated',
  },
  retryButton: {
    description: 'button label for the Retry button',
    defaultMessage: 'Retry',
    id: 'aaITTJ',
  },
  contactSupportLink: {
    description: 'label for the link that will take the user to an external site so they can contact support',
    defaultMessage: 'Contact Support',
    id: '+vTbsh',
  },
  fulfillmentProviderBundleDeactivationMessage: {
    description: 'message that shows when deactivating the Fulfillment Provider Bundle addon.',
    defaultMessage:
      'Deactivating the ShipStation 3PL add-on will disconnect your configured clients. You can deactivate these client stores, if desired, from the <link>Settings->Selling Channels->Store Setup</link> page.',
    id: 'YBwdSG',
  },
  dropshipManagerDeactivationMessage: {
    description: 'the message that shows when deactivating the Dropship Manager addon.',
    defaultMessage:
      'Deactivating the DropShip Manager add-on will disconnect your configured Vendors. Any orders delegated will not post back to your account.',
    id: 'nX0U0G',
  },
});
